import { render, staticRenderFns } from "./indexPromotions.vue?vue&type=template&id=bd12784c&scoped=true&"
import script from "./indexPromotions.vue?vue&type=script&lang=js&"
export * from "./indexPromotions.vue?vue&type=script&lang=js&"
import style0 from "./indexPromotions.vue?vue&type=style&index=0&id=bd12784c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd12784c",
  null
  
)

export default component.exports